import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import {
  InputHLPure,
  ArrowBtnHLPure,
  ButtonHLPure,
  DropDownBtnHLPure,
  TextAreaHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
  DialogYesNoHLPure,
  LabelModalPure
} from "../../pures";
import { useTranslation } from "react-i18next";
import "./business-administration-detail.css";
import { businessIconDefault } from "../../../assets/logos/icons";

const BusinessAdministrationDetailView = ({
  selectedUser,
  hideShowDetails,
  setStateNameComponentUser,
  validators,
  setHeaderTitleinDetail,
  optionsTypeBusiness,
  optionsBusinessTurnover,
  updateCompany,
  createCompany,
  token,
  nameComponentUser,
  changeImgFile,
  imgProfileSubtitle,
  handleChangeImgProfile,
  uploadFileCustom,
  setShowDetails,
  showWarningRequesting,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  message,
  imageProfile,
  procedureManager,
  registryTypes,
  pathView
}) => {
  const { t } = useTranslation();

  const redirectToComponets = (e) => {
    setStateNameComponentUser(e.currentTarget.dataset.id);
    setHeaderTitleinDetail({ clicked: true, name: e.currentTarget.dataset.id });
  };


  // const [imageSubtitle, setImageSubtitle] = useState(  nameComponentUser !== "Ver detalle/Editar" ? selectedUser?.imgProfile  : imageProfile)

  const [description, setDescription] = useState(
    nameComponentUser !== t("businessAdministrationPanelView.addCompany")
      ? selectedUser.company.description
      : ""
  );
  const [companyName, setCompanyName] = useState(
    nameComponentUser !== t("businessAdministrationPanelView.addCompany")
      ? selectedUser.companyName
      : ""
  );
  const [clientName, setClientName] = useState(
    nameComponentUser !== t("businessAdministrationPanelView.addCompany") ? selectedUser.clientName : ""
  );
  const [rfc, setRFC] = useState(
    nameComponentUser !== t("businessAdministrationPanelView.addCompany")
      ? selectedUser.company.rfc
      : ""
  );
  const [email, setEmail] = useState(
    nameComponentUser !== t("businessAdministrationPanelView.addCompany")
      ? selectedUser.company.rfc
      : ""
  );

  const [typeRegistry, setTypeRegistry] = useState((pathView === 'entities-administration') ? process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY : process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
  const [errorInRFC, setErrorInRFC] = useState(false);

  const [errorInBusinessName, setErrorInBusinessName] = useState(false);
  const [errorInNameSocial, setErrorInNameSocial] = useState(false);
  const [errorInDescription, setErrorInDescription] = useState(false);
  const [errorName, setErrorName] = useState(false)
  const [errorFirstLastName, setErrorFirstLastName] = useState(false)
  const [errorSecondLastName, setErrorSecondLastName] = useState(false)
  const [errorEmail, setErrorEmail] = useState(false)
  const [typeBusiness, setOptionsTypeBusiness] = useState(
    selectedUser.typeOfCompany || optionsTypeBusiness[0].typeOfCompany
  );
  const [businessTurnover, setOptionsBusinessTurnover] = useState(
    selectedUser.turnOfTheCompany || optionsBusinessTurnover[0].turnOfTheCompany
  );

  const [showModalWorkflow, setShowModalWorkflow] = useState(false)

  const handleChangeDescription = (e) => {
    setDescription(e.target.value);
  };
  const handleChangeRFC = (e) => {
    setRFC(e.target.value);
  };

  const handleChangeCompanyName = (e) => {
    setCompanyName(e.target.value);
  };

  const handleChangeClientName = (e) => {
    setClientName(e.target.value);
  };

  const handleChangeOptionsTypeBusiness = (e) => {
    setOptionsTypeBusiness(e.target.value);
  };

  const handleChangeOptionsBusinesTurnover = (e) => {
    setOptionsBusinessTurnover(e.target.value);
  };

  const [entityData, setEntityData] = useState(
    {
      name: "",
      firstLastName: "",
      secondLastName: "",
      rfc: "",
      description: "",
      email: ""
    }
  )

  const [entityOrganizationData, setEntityOrganizationData] = useState(
    {
      companyName: "",
      businessName: "",
      typeBusiness: "",
      rfc: "",
      businessTurnover: "",
      description: "",
      email: ""
    }
  )

  const handleSaveClientCompany = (createWorflow = false) => {
    const type = {
      name: typeRegistry,
      key: ""
    }

    switch (typeRegistry) {
      case "personOrganization":
        type.key = 1
        break
      case "personEntity":
        type.key = 2
        break
      default:
        type.key = 3
        break
    }

    const isEntity = typeRegistry !== "business"

    let bodyCreate = {}
    let bodyUpdate = {}

    if (typeRegistry === process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY) {
      let validateName = validators.nameValidator(entityData.name)
      let validateFirstLastName = validators.firstLastNameValidator(entityData.firstLastName)
      let validateSecondLastName = validators.secondLastNameValidator(entityData.secondLastName)
      let validateEmail = validators.emailValidator(email)
      let validateRFC = validators.rfcValidator(entityData.rfc)

      if (validateName !== '') {
        setErrorName(true)
        return
      }

      if (validateFirstLastName !== '') {
        setErrorFirstLastName(true)
        return
      }

      if (validateSecondLastName !== '') {
        setErrorSecondLastName(true)
        return
      }

      if (validateEmail !== '') {
        setErrorEmail(true)
        return
      }

      if (validateRFC !== '') {
        setErrorInRFC(true)
        return
      }

      bodyCreate = {
        entityBody: {
          name: entityData.name,
          firstLastName: entityData.firstLastName,
          secondLastName: entityData.secondLastName,
          email,
          createWorflow
        },
        companyType: type.name,
        rfc: entityData.rfc,
        isEntity,
        description: entityData.description ?? null
      };
    } else if (typeRegistry === process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY) {
      let validateName = validators.businessNameValidator(entityOrganizationData.companyName)
      let validateSocialName = validators.nameSocialValidator(entityOrganizationData.businessName)
      let validateEmail = validators.emailValidator(email)
      let validateRFC = validators.rfcValidator(entityOrganizationData.rfc)

      if (validateName !== '') {
        setErrorInBusinessName(true)
        return
      }

      if (validateSocialName !== '') {
        setErrorInNameSocial(true)
        return
      }

      if (validateEmail !== '') {
        setErrorEmail(true)
        return
      }

      if (validateRFC !== '') {
        setErrorInRFC(true)
        return
      }

      bodyCreate = {
        entityBody: {
          email,
          createWorflow
        },
        isEntity,
        companyType: type.name,
        companyName: entityOrganizationData.companyName,
        businessName: entityOrganizationData.businessName,
        typeOfCompany: entityOrganizationData.typeBusiness,
        rfc: entityOrganizationData.rfc,
        turnOfTheCompany: entityOrganizationData.businessTurnover,
        description: entityOrganizationData.description === "" ? null : entityOrganizationData.description,
      }
      bodyUpdate = {
        companyType: type.name,
        companyId: selectedUser.companyId,
        companyName: entityOrganizationData.companyName,
        businessName: entityOrganizationData.businessName,
        typeOfCompany: entityOrganizationData.typeBusiness,
        rfc: entityOrganizationData.rfc,
        turnOfTheCompany: entityOrganizationData.businessTurnover,
        description: entityOrganizationData.description === "" ? null : entityOrganizationData.description,
      };
    } else {
      let validateName = validators.businessNameValidator(companyName)
      let validateSocialName = validators.nameSocialValidator(clientName)
      let validateRFC = validators.rfcValidator(rfc)

      if (validateName !== '') {
        setErrorInBusinessName(true)
        return
      }

      if (validateSocialName !== '') {
        setErrorInNameSocial(true)
        return
      }

      if (validateRFC !== '') {
        setErrorInRFC(true)
        return
      }

      bodyCreate = {
        companyName: companyName,
        companyType: process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON,
        businessName: clientName,
        typeOfCompany: typeBusiness,
        rfc: rfc,
        turnOfTheCompany: businessTurnover,
        description: description === "" ? null : description,
      };
      bodyUpdate = {
        companyId: selectedUser.companyId,
        companyName: companyName,
        businessName: clientName,
        typeOfCompany: typeBusiness,
        rfc: rfc,
        turnOfTheCompany: businessTurnover,
        description: description === "" ? null : description,
      };
    }

    if (nameComponentUser === t("businessAdministrationPanelView.addCompany")) {
      createCompany(token, bodyCreate);
    } else {
      updateCompany(token, bodyUpdate);
    }
    // }
  };

  const handleShowCloseModalEntity = (value) => {
    setShowModalWorkflow(value)
  }

  const handleModalWorkflow = (value) => {
    handleSaveClientCompany(value)
    handleShowCloseModalEntity(false)
  }

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationAddNewUserView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="businessAdministrationAddressView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              nameComponentUser === t("businessAdministrationPanelView.addCompany")
                ? t("businessAdministrationPanelView.addCompany")
                : t("businessAdministrationPanelView.grid.actions.view.detail")
            }
            imgProfile={businessIconDefault}
            profileImg={
              nameComponentUser === t("businessAdministrationPanelView.grid.actions.view.detail")
                ? selectedUser?.imgProfile
                : imageProfile
            }
            tooltipShow
            openTooltipDescription={true}
            positionTooltip={"left"}
            titleTooltip={t("businessAdministrationDetailView.tooltip.logo.title")}
            descriptionTooltip={t("businessAdministrationDetailView.tooltip.logo.description")}
            informationIcon={false}
            altCustomImg={"Empresa"}
            // handleChangeImage={handleChangeImgProfile}
            uploadFile={(e) => uploadFileCustom(e)}
            changeImgFile={changeImgFile}
            justShowImg={false}
          />
        </Grid>
        <Grid
          item
          className="businessAdministrationAddressView-body"
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
        >
          {/*Container primera seccion de items, fila*/}
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationAddressView-form"
          >
            {/*Container first second items, col 1*/}

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="businessAdministrationAddressView-inputs"
            >
              {procedureManager
                ? typeRegistry === process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY
                  ?
                  <>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      es={3}
                      className="businessAdministrationAddressView-col1"
                    >
                      <Grid
                        item
                        className="businessAdministrationAddressView-inputHLPure"
                      >
                        <DropDownBtnHLPure
                          labelDropDown={t("businessAdministrationDetailView.drop.type.register")}
                          optionsDropDown={registryTypes}
                          valueItem={"key"}
                          nameOption={"key"}
                          optionsValue={process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON}
                          required
                          onDropDownChange={(e) => setTypeRegistry(e.target.value)}
                        />
                      </Grid>
                      <Grid
                        item
                        className="businessAdministrationAddressView-buttonHLPure"
                      >
                        <InputHLPure
                          labelInput={t("businessAdministrationDetailView.name")}
                          valueInput={entityData.name}
                          typeInput={"text"}
                          required
                          handleChangeInput={(e) => {
                            setEntityData({ ...entityData, name: e.target.value })
                            setErrorName(false)
                          }
                          }
                          inputActive
                          errorInput={errorName}
                          errorInputText={t(
                            "businessAdministrationDetailView.errorEntityName"
                          )}
                          tooltipShow
                          informationIcon
                          positionTooltip={"top"}
                          titleTooltip={t("businessAdministrationDetailView.tooltip.name.title")}
                          descriptionTooltip={`${t("businessAdministrationDetailView.businessNameTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                        />
                      </Grid>
                      <Grid
                        item
                        className="businessAdministrationAddressView-inputHLPure"
                      >
                        <InputHLPure
                          labelInput={t("businessAdministrationDetailView.lastname")}
                          valueInput={entityData.firstLastName}
                          typeInput={"text"}
                          required
                          handleChangeInput={(e) => {
                            setEntityData({ ...entityData, firstLastName: e.target.value })
                            setErrorFirstLastName(false)
                          }}
                          inputActive
                          errorInput={errorFirstLastName}
                          errorInputText={t(
                            "businessAdministrationDetailView.errorEntityFirstLastName"
                          )}
                          tooltipShow
                          informationIcon
                          positionTooltip={"top"}
                          titleTooltip={t("businessAdministrationDetailView.person.lastname")}
                          descriptionTooltip={`${t("businessAdministrationDetailView.nameSocialTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                        />
                      </Grid>
                      <Grid
                        item
                        className="businessAdministrationAddressView-inputHLPure"
                      >
                        <InputHLPure
                          labelInput={t("businessAdministrationDetailView.second.lastname")}
                          valueInput={entityData.secondLastName}
                          typeInput={"text"}
                          required
                          handleChangeInput={(e) => {
                            setEntityData({ ...entityData, secondLastName: e.target.value })
                            setErrorSecondLastName(false)
                          }}
                          inputActive
                          errorInput={errorSecondLastName}
                          errorInputText={t(
                            "businessAdministrationDetailView.errorNameSocial"
                          )}
                          tooltipShow
                          informationIcon
                          positionTooltip={"top"}
                          titleTooltip={t("businessAdministrationDetailView.person.second.lastname")}
                          descriptionTooltip={`${t("businessAdministrationDetailView.nameSocialTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="businessAdministrationAddressView-col2"
                    >
                      <Grid
                        item
                        className="businessAdministrationAddressView-inputHLPure"
                      >
                        <InputHLPure
                          labelInput={t("businessAdministrationDetailView.rfc")}
                          typeInput={"text"}
                          valueInput={entityData.rfc}
                          handleChangeInput={(e) => {
                            setEntityData({ ...entityData, rfc: e.target.value })
                            setErrorInRFC(false)
                          }}
                          inputActive
                          required
                          errorInput={errorInRFC}
                          errorInputText={t(
                            "businessAdministrationDetailView.errorRFC"
                          )}
                          tooltipShow
                          informationIcon
                          positionTooltip={"top"}
                          titleTooltip={t("businessAdministrationDetailView.rfc")}
                          descriptionTooltip={t("businessAdministrationDetailView.RFCTooltip")}
                        />
                      </Grid>
                      <Grid
                        item
                        className="businessAdministrationAddressView-dropDownBtnHLPure"
                      >
                        <TextAreaHLPure
                          labelTextArea={t("businessAdministrationDetailView.description")}
                          typeInput={"text"}
                          handleChangeTextArea={(e) => setEntityData({ ...entityData, description: e.target.value })}
                          valueTextData={entityData.description}
                          errorInput={errorInDescription}
                          errorTextArea={t(
                            "businessAdministrationDetailView.errorDescription"
                          )}
                          tooltipShow
                          informationIcon
                          positionTooltip={"top"}
                          titleTooltip={t("businessAdministrationDetailView.description")}
                          descriptionTooltip={`${t("businessAdministrationDetailView.descriptionTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                        />
                      </Grid>
                    </Grid>
                  </>
                  : typeRegistry === process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY
                    ?
                    <>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        es={3}
                        className="businessAdministrationAddressView-col1"
                      >
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <DropDownBtnHLPure
                            labelDropDown={t("businessAdministrationDetailView.drop.type.register")}
                            optionsDropDown={registryTypes}
                            valueItem={"key"}
                            nameOption={"key"}
                            optionsValue={process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON}
                            required
                            onDropDownChange={(e) => setTypeRegistry(e.target.value)}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-buttonHLPure"
                        >
                          <InputHLPure
                            labelInput={t("businessAdministrationDetailView.bussiness.name")}
                            valueInput={entityOrganizationData.companyName}
                            typeInput={"text"}
                            required
                            handleChangeInput={(e) => {
                              setEntityOrganizationData({ ...entityOrganizationData, companyName: e.target.value })
                              setErrorInBusinessName(false)
                            }}
                            inputActive
                            errorInput={errorInBusinessName}
                            errorInputText={t(
                              "businessAdministrationDetailView.errorBusinessName"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.bussiness.name")}
                            descriptionTooltip={`${t("businessAdministrationDetailView.businessNameTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <InputHLPure
                            labelInput={t("businessAdministrationDetailView.legal.name")}
                            valueInput={entityOrganizationData.businessName}
                            typeInput={"text"}
                            required
                            handleChangeInput={(e) => {
                              setEntityOrganizationData({ ...entityOrganizationData, businessName: e.target.value })
                              setErrorInNameSocial(false)
                            }}
                            inputActive
                            errorInput={errorInNameSocial}
                            errorInputText={t(
                              "businessAdministrationDetailView.errorNameSocial"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.legal.name")}
                            descriptionTooltip={`${t("businessAdministrationDetailView.nameSocialTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <DropDownBtnHLPure
                            labelDropDown={t("businessAdministrationDetailView.company.type")}
                            required
                            optionsDropDown={optionsTypeBusiness}
                            valueItem={"typeOfCompany"}
                            nameOption={"typeOfCompany"}
                            optionsValue={entityOrganizationData.typeBusiness}
                            onDropDownChange={(e) => setEntityOrganizationData({ ...entityOrganizationData, typeBusiness: e.target.value })}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="businessAdministrationAddressView-col2"
                      >
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <InputHLPure
                            labelInput={t("businessAdministrationDetailView.rfc")}
                            typeInput={"text"}
                            valueInput={entityOrganizationData.rfc}
                            handleChangeInput={(e) => {
                              setEntityOrganizationData({ ...entityOrganizationData, rfc: e.target.value })
                              setErrorInRFC(false)
                            }}
                            inputActive
                            required
                            errorInput={errorInRFC}
                            errorInputText={t(
                              "businessAdministrationDetailView.errorRFC"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.rfc")}
                            descriptionTooltip={t("businessAdministrationDetailView.RFCTooltip")}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-dropDownBtnHLPure"
                        >
                          <DropDownBtnHLPure
                            labelDropDown={t("businessAdministrationDetailView.business.activity")}
                            optionsDropDown={optionsBusinessTurnover}
                            valueItem={"turnOfTheCompany"}
                            nameOption={"turnOfTheCompany"}
                            optionsValue={entityOrganizationData.businessTurnover}
                            required
                            onDropDownChange={(e) =>
                              setEntityOrganizationData({ ...entityOrganizationData, businessTurnover: e.target.value })
                            }
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-dropDownBtnHLPure"
                        >
                          <TextAreaHLPure
                            labelTextArea={t("businessAdministrationDetailView.description")}
                            typeInput={"text"}
                            handleChangeTextArea={(e) => setEntityOrganizationData({ ...entityOrganizationData, description: e.target.value })}
                            valueTextData={entityOrganizationData.description}
                            errorInput={errorInDescription}
                            errorTextArea={t(
                              "businessAdministrationDetailView.errorDescription"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.description")}
                            descriptionTooltip={`${t("businessAdministrationDetailView.descriptionTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                          />
                        </Grid>
                      </Grid>
                    </>
                    :
                    <>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        es={3}
                        className="businessAdministrationAddressView-col1"
                      >
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <DropDownBtnHLPure
                            labelDropDown={t("businessAdministrationDetailView.drop.type.register")}
                            optionsDropDown={registryTypes}
                            valueItem={"key"}
                            nameOption={"key"}
                            optionsValue={process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON}
                            required
                            onDropDownChange={(e) => setTypeRegistry(e.target.value)}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-buttonHLPure"
                        >
                          <InputHLPure
                            labelInput={t("businessAdministrationDetailView.bussiness.name")}
                            valueInput={companyName}
                            typeInput={"text"}
                            required
                            handleChangeInput={(e) => {
                              handleChangeCompanyName(e)
                            }}
                            inputActive
                            errorInput={errorInBusinessName}
                            errorInputText={t(
                              "businessAdministrationDetailView.errorBusinessName"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.bussiness.name")}
                            descriptionTooltip={`${t("businessAdministrationDetailView.businessNameTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <InputHLPure
                            labelInput={t("businessAdministrationDetailView.legal.name")}
                            valueInput={clientName}
                            typeInput={"text"}
                            required
                            handleChangeInput={(e) => {
                              handleChangeClientName(e)
                            }}
                            inputActive
                            errorInput={errorInNameSocial}
                            errorInputText={t(
                              "businessAdministrationDetailView.errorNameSocial"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.legal.name")}
                            descriptionTooltip={`${t("businessAdministrationDetailView.nameSocialTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <DropDownBtnHLPure
                            labelDropDown={t("businessAdministrationDetailView.company.type")}
                            optionsDropDown={optionsTypeBusiness}
                            valueItem={"typeOfCompany"}
                            nameOption={"typeOfCompany"}
                            optionsValue={typeBusiness}
                            required
                            onDropDownChange={(e) => handleChangeOptionsTypeBusiness(e)}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="businessAdministrationAddressView-col2"
                      >
                        <Grid
                          item
                          className="businessAdministrationAddressView-inputHLPure"
                        >
                          <InputHLPure
                            labelInput={t("businessAdministrationDetailView.rfc")}
                            typeInput={"text"}
                            valueInput={rfc}
                            handleChangeInput={(e) => {
                              handleChangeRFC(e)
                            }}
                            inputActive
                            required
                            errorInput={errorInRFC}
                            errorInputText={t(
                              "businessAdministrationDetailView.errorRFC"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.rfc")}
                            descriptionTooltip={t("businessAdministrationDetailView.RFCTooltip")}
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-dropDownBtnHLPure"
                        >
                          <DropDownBtnHLPure
                            labelDropDown={t("businessAdministrationDetailView.business.activity")}
                            optionsDropDown={optionsBusinessTurnover}
                            valueItem={"turnOfTheCompany"}
                            nameOption={"turnOfTheCompany"}
                            optionsValue={businessTurnover}
                            required
                            onDropDownChange={(e) =>
                              handleChangeOptionsBusinesTurnover(e)
                            }
                          />
                        </Grid>
                        <Grid
                          item
                          className="businessAdministrationAddressView-dropDownBtnHLPure"
                        >
                          <TextAreaHLPure
                            labelTextArea={t("businessAdministrationDetailView.description")}
                            typeInput={"text"}
                            handleChangeTextArea={(e) => handleChangeDescription(e)}
                            valueTextData={description}
                            errorInput={errorInDescription}
                            errorTextArea={t(
                              "businessAdministrationDetailView.errorDescription"
                            )}
                            tooltipShow
                            informationIcon
                            positionTooltip={"top"}
                            titleTooltip={t("businessAdministrationDetailView.description")}
                            descriptionTooltip={`${t("businessAdministrationDetailView.descriptionTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                          />
                        </Grid>
                      </Grid>
                    </>
                :
                <>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    es={3}
                    className="businessAdministrationAddressView-col1"
                  >
                    <Grid
                      item
                      className="businessAdministrationAddressView-buttonHLPure"
                    >
                      <InputHLPure
                        labelInput={t("businessAdministrationDetailView.bussiness.name")}
                        valueInput={companyName}
                        typeInput={"text"}
                        required
                        handleChangeInput={(e) => {
                          handleChangeCompanyName(e)
                          setErrorInBusinessName(false)
                        }}
                        inputActive
                        errorInput={errorInBusinessName}
                        errorInputText={t(
                          "businessAdministrationDetailView.errorBusinessName"
                        )}
                        tooltipShow
                        informationIcon
                        positionTooltip={"top"}
                        titleTooltip={t("businessAdministrationDetailView.bussiness.name")}
                        descriptionTooltip={`${t("businessAdministrationDetailView.businessNameTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                      />
                    </Grid>
                    <Grid
                      item
                      className="businessAdministrationAddressView-inputHLPure"
                    >
                      <InputHLPure
                        labelInput={t("businessAdministrationDetailView.legal.name")}
                        valueInput={clientName}
                        typeInput={"text"}
                        required
                        handleChangeInput={(e) => {
                          handleChangeClientName(e)
                          setErrorInNameSocial(false)
                        }}
                        inputActive
                        errorInput={errorInNameSocial}
                        errorInputText={t(
                          "businessAdministrationDetailView.errorNameSocial"
                        )}
                        tooltipShow
                        informationIcon
                        positionTooltip={"top"}
                        titleTooltip={t("businessAdministrationDetailView.legal.name")}
                        descriptionTooltip={`${t("businessAdministrationDetailView.nameSocialTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                      />
                    </Grid>
                    <Grid
                      item
                      className="businessAdministrationAddressView-inputHLPure"
                    >
                      <DropDownBtnHLPure
                        labelDropDown={t("businessAdministrationDetailView.company.type")}
                        optionsDropDown={optionsTypeBusiness}
                        valueItem={"typeOfCompany"}
                        nameOption={"typeOfCompany"}
                        optionsValue={typeBusiness}
                        required
                        onDropDownChange={(e) => handleChangeOptionsTypeBusiness(e)}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="businessAdministrationAddressView-col2"
                  >
                    <Grid
                      item
                      className="businessAdministrationAddressView-inputHLPure"
                    >
                      <InputHLPure
                        labelInput={t("businessAdministrationDetailView.rfc")}
                        typeInput={"text"}
                        valueInput={rfc}
                        handleChangeInput={(e) => {
                          handleChangeRFC(e)
                          setErrorInRFC(false)
                        }}
                        inputActive
                        required
                        errorInput={errorInRFC}
                        errorInputText={t(
                          "businessAdministrationDetailView.errorRFC"
                        )}
                        tooltipShow
                        informationIcon
                        positionTooltip={"top"}
                        titleTooltip={t("businessAdministrationDetailView.rfc")}
                        descriptionTooltip={t("businessAdministrationDetailView.RFCTooltip")}
                      />
                    </Grid>
                    <Grid
                      item
                      className="businessAdministrationAddressView-dropDownBtnHLPure"
                    >
                      <DropDownBtnHLPure
                        labelDropDown={t("businessAdministrationDetailView.business.activity")}
                        optionsDropDown={optionsBusinessTurnover}
                        valueItem={"turnOfTheCompany"}
                        nameOption={"turnOfTheCompany"}
                        optionsValue={businessTurnover}
                        required
                        onDropDownChange={(e) =>
                          handleChangeOptionsBusinesTurnover(e)
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      className="businessAdministrationAddressView-dropDownBtnHLPure"
                    >
                      <TextAreaHLPure
                        labelTextArea={t("businessAdministrationDetailView.description")}
                        typeInput={"text"}
                        handleChangeTextArea={(e) => handleChangeDescription(e)}
                        valueTextData={description}
                        errorInput={errorInDescription}
                        errorTextArea={t(
                          "businessAdministrationDetailView.errorDescription"
                        )}
                        tooltipShow
                        informationIcon
                        positionTooltip={"top"}
                        titleTooltip={t("businessAdministrationDetailView.description")}
                        descriptionTooltip={`${t("businessAdministrationDetailView.descriptionTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                      />
                    </Grid>
                  </Grid>
                </>}
            </Grid>
            {(procedureManager && typeRegistry !== process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON) &&
              <Grid
                item
                className="businessAdministrationAddressView-inputHLPure"
              >
                <InputHLPure
                  labelInput={t("businessAdministrationDetailView.email")}
                  typeInput={"text"}
                  valueInput={email}
                  handleChangeInput={(e) => {
                    setEmail(e.target.value)
                    setErrorEmail(false)
                  }}
                  inputActive
                  required
                  errorInput={errorEmail}
                  errorInputText={t(
                    "businessAdministrationDetailView.errorEmail"
                  )}
                  tooltipShow
                  informationIcon
                  positionTooltip={"top"}
                  titleTooltip={t("businessAdministrationDetailView.email")}
                  descriptionTooltip={t("businessAdministrationDetailView.emailTooltip")}
                />
              </Grid>}
            <Grid item xs={12}>
              <p className="businessAdministrationDetailView-required-label"><span>*</span> {t("businessAdministrationDetailView.requiredFields")}</p>
            </Grid>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationDetailView-btnGroup"
          >
            <div className="businessAdministrationDetailView-spaceBtns">
              <ButtonHLPure
                primary={false}
                nameBtn={t("button.cancel")}
                onClickBtn={hideShowDetails}
              />
            </div>
            {nameComponentUser !== t("businessAdministrationPanelView.addCompany") ? (
              <>
                <div className="businessAdministrationDetailView-spaceBtns">
                  <ArrowBtnHLPure
                    textArrowBtn={t("businessAdministrationPanelView.grid.actions.address")}
                    onClickArrowBtn={() => {
                      setStateNameComponentUser(t("businessAdministrationPanelView.grid.actions.address"));
                      setShowDetails(true);
                    }}
                    dataSetProp={t("businessAdministrationPanelView.grid.actions.address")}
                    primary={false}
                  />
                </div>
                <div className="businessAdministrationDetailView-spaceBtns">
                  <ArrowBtnHLPure
                    textArrowBtn={t("businessAdministrationPanelView.grid.actions.sat")}
                    onClickArrowBtn={() => {
                      setStateNameComponentUser(t("businessAdministrationPanelView.grid.actions.sat"));
                      setShowDetails(true);
                    }}
                    dataSetProp={t("businessAdministrationPanelView.grid.actions.sat")}
                    primary={false}
                  />
                </div>
                <div className="businessAdministrationDetailView-spaceBtns">
                  <ArrowBtnHLPure
                    textArrowBtn={t("businessAdministrationPanelView.grid.actions.disable")}
                    onClickArrowBtn={() => {
                      setStateNameComponentUser(t("businessAdministrationPanelView.grid.actions.disable"));
                      setShowDetails(true);
                    }}
                    dataSetProp={t("businessAdministrationPanelView.grid.actions.disable")}
                  />
                </div>
              </>
            ) : (
              ""
            )}

            <ButtonHLPure
              primary
              nameBtn={t("button.save")}
              onClickBtn={(pathView === 'entities-administration') ? () => handleShowCloseModalEntity(true) : handleSaveClientCompany}
            />
          </Grid>
          {
            showModalWorkflow && (
              <DialogYesNoHLPure
                cancel={() => handleModalWorkflow(false)}
                textBtnCancel={t("button.reject")}
                saveBtn={t("button.accept")}
                titleDialog={t("businessAdministrationPanelView.modal.title")}
                handleSubmit={() => handleModalWorkflow(true)}
                btnCancel={true}
                handleCancel={() => handleShowCloseModalEntity(false)}
              >
                <div className='businessAdministrationDetailView-dialog-delete'>
                  <LabelModalPure label={t("businessAdministrationPanelView.modal.question")} />
                  <LabelModalPure label={`${t("businessAdministrationPanelView.modal.description.1")} ${(typeRegistry === process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY) ? entityData.name : entityOrganizationData.companyName} ${t("businessAdministrationPanelView.modal.description.2")} ${(typeRegistry === process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY) ? entityData.email : entityOrganizationData.email} ${t("businessAdministrationPanelView.modal.description.3")}`} />
                </div>
              </DialogYesNoHLPure>
            )
          }
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            message={message}
          />
        </Grid>
      </>
    </Grid>
  );
};

export default BusinessAdministrationDetailView;
